import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';

export function NotFoundPage(): ReactNode {
  return (
    <Layout>
      <div className="card">
        <h1>Seite nicht gefunden</h1>
        <p>Die aufgerufene Adresse existiert nicht.</p>
        <Link className="button button--ghost" to="/">
          Zur Startseite
        </Link>
      </div>
    </Layout>
  );
}
